import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cityReadAction from './cityRead.action.json' with { type: 'json' }

const cityReadDefinition = defineReadAutoAction(cityReadAction, 'city')

export default cityReadDefinition
